module.exports = require('./DepCollectiveInvestmentFundFilingView');
